module.exports = require('./DepCollectiveInvestmentFundFilingView');
